import { Children } from 'react'
import PropTypes from 'prop-types'
import { withContext } from 'recompose'

import theme from '@/styles/mobi/theme.css'

const withIThemeContext = withContext({ theme: PropTypes.object }, () => ({ theme }))

const ThemeProvider = ({ children }) => Children.only(children)

export default withIThemeContext(ThemeProvider)



// WEBPACK FOOTER //
// ./ui/Theme/ThemeProvider.js